import { ArrowUpRight } from "lucide-react";
import Reveal from "@/components/site/Reveal";
import { CHECKOUT_URL } from "@/constants/site";

const chapters = [
  { title: "A verdade sobre o que funcionava parou de funcionar", text: "Entenda o que mudou no seu corpo depois dos 40 — e por que a culpa nunca foi sua." },
  { title: "O que muda quando existe método", text: "A diferença entre colecionar informação e seguir uma ordem que gera resultado." },
  { title: "Antes de começar: o mínimo necessário", text: "Simplifique antes de escalar. O essencial para largar na frente sem se sabotar." },
  { title: "Passo 1 — Escolher o ponto de partida", text: "Comece do que já existe na sua rotina, com blocos focados e realistas." },
  { title: "Passo 2 — Montar o seu Plano 40+", text: "Um plano que não depende de inspiração: um processo repetível, feito para você." },
  { title: "Passo 3 — A primeira semana na prática", text: "O que fazer a cada dia, na ordem certa, e o que esperar dos primeiros 7 dias." },
  { title: "Passo 4 — Medir o que importa", text: "As métricas que mostram progresso real — e como não se sabotar ao ler os números." },
  { title: "Passo 5 — Ajustar sem recomeçar", text: "Corrija a rota sem jogar fora o progresso. Deslize não é recomeço do zero." },
  { title: "Os erros que custam caro", text: "Os obstáculos que mais derrubam quem tem 40+ — e como atravessar cada um." },
  { title: "Manter o ritmo sem depender de motivação", text: "O que fazer nas semanas de baixa vontade: trate o problema real, não o sintoma." },
  { title: "Da primeira roupa que serviu de novo ao próximo nível", text: "O que fazer depois dos primeiros resultados para não estagnar." },
  { title: "Os próximos 30 dias", text: "O roteiro de 4 semanas para consolidar: repetir, ajustar, ampliar, revisar." },
];

const Chapters = () => (
  <section
    id="capitulos"
    data-testid="chapters-section"
    className="border-y border-border bg-secondary/50 py-24 lg:py-32"
  >
    <div className="mx-auto grid max-w-7xl grid-cols-1 gap-14 px-4 sm:px-6 lg:grid-cols-12 lg:gap-10 lg:px-8">
      <div className="lg:col-span-4">
        <div className="lg:sticky lg:top-28">
          <Reveal>
            <p className="eyebrow mb-5 text-accent">Dentro do ebook</p>
            <h2 className="font-display text-3xl font-semibold leading-tight tracking-tight text-foreground sm:text-4xl lg:text-5xl">
              12 capítulos.
              <br />
              <span className="italic text-primary">Um caminho só.</span>
            </h2>
            <p className="mt-6 leading-relaxed text-muted-foreground">
              Cada capítulo termina com exercícios e checklists práticos — você lê, aplica e mede.
              Nada de teoria solta.
            </p>
            <a
              data-testid="chapter-cta-button"
              href={CHECKOUT_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-shine group mt-8 inline-flex items-center gap-3 rounded-full bg-primary px-7 py-3.5 text-sm font-semibold text-primary-foreground transition-[transform,box-shadow] duration-300 hover:-translate-y-0.5 hover:shadow-xl"
            >
              Quero começar agora
              <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </a>
          </Reveal>
        </div>
      </div>

      <div className="lg:col-span-8" data-testid="chapter-card-list">
        {chapters.map((chapter, i) => (
          <Reveal key={chapter.title} delay={Math.min(i * 0.05, 0.3)} y={24}>
            <div
              data-testid={`chapter-item-${i + 1}`}
              className="group flex items-baseline gap-6 border-t border-border py-6 transition-[background-color,padding] duration-300 last:border-b hover:bg-card/70 hover:pl-3 sm:gap-10"
            >
              <span className="font-mono-accent text-sm font-semibold text-accent">
                {String(i + 1).padStart(2, "0")}
              </span>
              <div className="flex-1">
                <h3 className="font-display text-xl font-semibold leading-snug text-foreground sm:text-2xl">
                  {chapter.title}
                </h3>
                <p className="mt-2 max-w-xl text-sm leading-relaxed text-muted-foreground sm:text-base">
                  {chapter.text}
                </p>
              </div>
              <ArrowUpRight className="hidden h-5 w-5 shrink-0 self-center text-primary opacity-0 transition-[opacity,transform] duration-300 group-hover:translate-x-0.5 group-hover:opacity-100 sm:block" />
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Chapters;
